import React from "react";
import { DateObject } from "../../../../domain/fundamental/DateObject";
import dayjs from "dayjs";
import { LeftArrowIcon } from "../../common/icons/LeftArrowIcon";
import { RightArrowIcon } from "../../common/icons/RightArrowIcon";
import { Month } from "../../../../domain/fundamental/Month";
import classNames from "classnames";

export function SingleCalendar(props: Props) {

    const { startDate, endDate, onClickDate, month, previousMonth, previousMonthDisabled, nextMonth, nextMonthDisabled, hoverDate, setHoverDate, dateDisabled } = props;

    const weekdays = ["日", "月", "火", "水", "木", "金", "土"];

    const firstDay = dayjs(month.format()).startOf("month");
    const firstDayIndex = firstDay.day();
    const cells = () => {
        return [...Array(42)].map((_v, i) => {
            const date = DateObject.fromString(dayjs(firstDay).add(i - firstDayIndex, "day").format("YYYY-MM-DD"));

            // 選択済み期間とホバー期間が重なる場合はホバー期間を優先する
            const isSelectedArea = date.isEqualsOrLessThan(endDate) && date.isEqualsOrGreaterThan(startDate);
            const hoverAreaStartDay = hoverDate ? hoverDate.addDay(-29): null;
            const isHoverArea = hoverDate && hoverAreaStartDay && date.isEqualsOrGreaterThan(hoverAreaStartDay) && date.isEqualsOrLessThan(hoverDate);
            const areaClass = classNames("day__container", {
                "selected_area": isHoverArea ? false : isSelectedArea,
                "selected_area_start": isHoverArea ? false : date.equals(startDate),
                "selected_area_end": isHoverArea ? false : date.equals(endDate),
                "hover_area": isHoverArea,
                "hover_area_start": hoverAreaStartDay && date.equals(hoverAreaStartDay),
                "hover_area_end": hoverDate && date.equals(hoverDate)
            });
            const disabled = dateDisabled && dateDisabled(date);

            const dateClass = classNames({
                "day": date.month === month.month,
                "not_current_month": date.month !== month.month,
                "selected_date": isHoverArea ? false : date.equals(endDate),
                "hover_date": hoverDate && date.equals(hoverDate),
                "date_disabled": disabled
            });
            return (
                <div className={areaClass} key={date.format()}>
                    <button
                        className={dateClass}
                        onClick={() => { onClickDate(date); setHoverDate(null); }}
                        onMouseOver={() => setHoverDate(date)}
                        disabled={disabled}
                    >
                        {date.date}
                    </button>
                </div>
            );
        });
    };

    return (
        <div className={"single_calendar"}>
            <button className={"previous_month"} disabled={previousMonthDisabled} onClick={() => previousMonth && previousMonth()} aria-label={"前月"}><LeftArrowIcon/></button>
            <button className={"next_month"} disabled={nextMonthDisabled} onClick={() => nextMonth && nextMonth()} aria-label={"翌月"}><RightArrowIcon/></button>
            <div className={"year_month"}>{`${month.japaneseFormat(false)}`}</div>
            <div className={"weekdays"}>{ weekdays.map(weekday => (<div className={"weekday"} key={weekday}>{weekday}</div>))}</div>
            <div className={"days"} onMouseLeave={() => setHoverDate(null)}>{cells()}</div>
        </div>
    );
}

type Props = {
    startDate: DateObject
    endDate: DateObject
    selectedDate?: DateObject
    onClickDate:  (value: DateObject) => void
    month: Month
    previousMonth?: () => void
    previousMonthDisabled?: boolean
    nextMonth?: () => void
    nextMonthDisabled?: boolean
    hoverDate: DateObject | null
    setHoverDate: (date: DateObject | null) => void
    dateDisabled?: (date: DateObject) => boolean
}